import { gql } from '@apollo/client';
import { apolloClient } from 'core/apollo-client';

const UPDATE_TASK_DATA = gql`
  mutation UpdateTaskData($taskId: ID!, $accountId: ID!, $data: AWSJSON!) {
    updateTaskData(taskId: $taskId, accountId: $accountId, data: $data) {
      ... on UpdateTaskData {
        success
        task {
          taskId
          accountId
          data
        }
      }
      ... on OnboardingTasksError {
        error
      }
    }
  }
`;

/**
 * Update task data field without completing the task
 * Used to save draft document URLs
 */
export const updateTaskData = async (taskId, accountId, data) => {
  try {
    const { data: result } = await apolloClient.mutate({
      mutation: UPDATE_TASK_DATA,
      variables: {
        taskId,
        accountId,
        data: JSON.stringify(data)
      }
    });

    if (result?.updateTaskData?.__typename === 'OnboardingTasksError') {
      throw new Error(result.updateTaskData.error || 'Failed to update task data');
    }

    return result?.updateTaskData;
  } catch (error) {
    console.error('Error updating task data:', error);
    throw error;
  }
};
